import type { ConsentConfiguration } from '@maestro/commerce-blocks/theme/theme.types'
import type { Consent } from '@maestro/data-layer'

import { createRegisterFormSchema } from '@maestro/commerce-blocks/schemas/forms/register-form.schema'

export const createUpdateProfileFormSchema = (
  consents: Consent[],
  consentConfigurations: ConsentConfiguration[]
) =>
  createRegisterFormSchema(consents, consentConfigurations).omit({
    password: true,
  })
